import React, { useCallback, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ProgressBar from '@tcp/core/src/components/common/atoms/ProgressBar/views/ProgressBar';
import {
  CarouselButton,
  StyledCarouselPaginatorContainer,
  StyledNextArrow,
  StyledOutfitCarousel,
  StyledOutfitImage,
  StyledPrevArrow,
} from '../styles/OutfitCarousel.style';
import TouchSlider from './TouchSlider';
import SafeComponent from '../../../../../common/hoc/withErrorBoundary/errorBoundary';

const OutfitCarousel = ({
  getOutfit,
  currentImageIndex,
  setCurrentImageIndex,
  selectedProductsLists,
  currentOutfitProducts,
}) => {
  const [currentOutfit, setCurrentOutfit] = useState(currentOutfitProducts);
  const [delay, setDelay] = useState(500);

  const colorProductIds =
    currentOutfit && currentOutfit?.items?.map((item) => item.remoteId || item.remote_id).join('-');

  useLayoutEffect(() => {
    if (selectedProductsLists) {
      setCurrentOutfit(selectedProductsLists[currentImageIndex]);
    }
  }, [currentImageIndex, selectedProductsLists]);

  const previousImage = useCallback(() => {
    const newIndex =
      currentImageIndex === 0 ? selectedProductsLists.length - 1 : currentImageIndex - 1;
    setCurrentImageIndex(newIndex);
  }, [currentImageIndex]);

  const nextImage = useCallback(() => {
    const newIndex =
      currentImageIndex === selectedProductsLists.length - 1 ? 0 : currentImageIndex + 1;
    setCurrentImageIndex(newIndex);
  }, [currentImageIndex]);

  useLayoutEffect(() => {
    if (colorProductIds) {
      getOutfit({
        outfitId: currentOutfit?.id,
        vendorColorProductIdsList: colorProductIds,
        fromOutFitPage: true,
        debounce: delay,
      });
    }
  }, [currentOutfit, getOutfit, currentImageIndex]);

  return (
    <>
      <StyledOutfitCarousel>
        {currentImageIndex > 0 && (
          <CarouselButton onClick={previousImage} left>
            <StyledPrevArrow />
          </CarouselButton>
        )}
        <StyledOutfitImage
          key={`${currentOutfit?.id}-${currentImageIndex}`}
          src={currentOutfit?.image_url || currentOutfit?.imageUrl}
          alt="carousel"
        />
        {(selectedProductsLists.length > 1 || currentImageIndex > 0) &&
          currentImageIndex !== selectedProductsLists.length - 1 && (
            <CarouselButton onClick={nextImage} right>
              <StyledNextArrow />
            </CarouselButton>
          )}
      </StyledOutfitCarousel>
      <TouchSlider
        selectedProductsLists={selectedProductsLists}
        setCurrentImageIndex={setCurrentImageIndex}
        setDelay={setDelay}
      />
      <StyledCarouselPaginatorContainer>
        {selectedProductsLists.length > 1 && (
          <ProgressBar
            value={((currentImageIndex + 1) / selectedProductsLists?.length) * 100}
            max={100}
          />
        )}
      </StyledCarouselPaginatorContainer>
    </>
  );
};

export default SafeComponent(OutfitCarousel);

OutfitCarousel.propTypes = {
  getOutfit: PropTypes.func,
  currentImageIndex: PropTypes.number,
  setCurrentImageIndex: PropTypes.func,
  selectedProductsLists: PropTypes.shape([]),
  currentOutfitProducts: PropTypes.shape({}),
};

OutfitCarousel.defaultProps = {
  getOutfit: () => {},
  currentImageIndex: 0,
  setCurrentImageIndex: () => {},
  selectedProductsLists: [],
  currentOutfitProducts: {},
};
